import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/address-card': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H528C554.5 480 576 458.5 576 432V80C576 53.5 554.5 32 528 32zM528 432H48V80H528V432zM208 256C243.3 256 272 227.3 272 192S243.3 128 208 128 144 156.7 144 192 172.7 256 208 256zM118.4 384H297.6C310 384 320 375.4 320 364.8V345.6C320 313.8 289.9 288 252.8 288 242 288 234.1 296 208 296 181.1 296 174.6 288 163.2 288 126.1 288 96 313.8 96 345.6V364.8C96 375.4 106 384 118.4 384zM360 320H472C476.4 320 480 316.4 480 312V296C480 291.6 476.4 288 472 288H360C355.6 288 352 291.6 352 296V312C352 316.4 355.6 320 360 320zM360 256H472C476.4 256 480 252.4 480 248V232C480 227.6 476.4 224 472 224H360C355.6 224 352 227.6 352 232V248C352 252.4 355.6 256 360 256zM360 192H472C476.4 192 480 188.4 480 184V168C480 163.6 476.4 160 472 160H360C355.6 160 352 163.6 352 168V184C352 188.4 355.6 192 360 192z'
      }
    ]
  }
})
